import React, { useState, useEffect, useMemo } from 'react';
import dayjs from 'dayjs';
import { Button, Space, Checkbox, Row, Col, message } from "antd";
import { useNavigate } from 'react-router-dom';
import { downloadFile } from '../../utils/utils';
import axiosInstance from '../../utils/axiosInstance';
import { FolderOpenOutlined } from '@ant-design/icons';

const MyButtonWithCheckbox = ({ financialYear, enableMonths }) => {
  const [selectedItems, setSelectedItems] = useState([]);
  const [isSelAll, setIsSelAll] = useState(false);
  const navigate = useNavigate();

  const mnLst = useMemo(() => {
    const [startYear, endYear] = financialYear.split('-');
    const startMonth = dayjs(`${startYear}-04-01`).utc();
    const endMonth = dayjs(`${endYear}-04-01`).utc();
    const now = dayjs().utc();

    const data = [];
    let currentMonth = startMonth.clone();

    while (currentMonth.isBefore(endMonth) && currentMonth.isBefore(now)) {
      data.push({
        label: currentMonth.format("MMMM YYYY"),
        key: currentMonth.format("YYYY-MM")
      });
      currentMonth = currentMonth.add(1, 'month');
    }

    return data;
  }, [financialYear]);

  const handleCheckboxChange = (checkedValues) => {
    setIsSelAll(checkedValues.length === mnLst.length);
    setSelectedItems(checkedValues);
  };

  const handleSelectAllChange = (e) => {
    const { checked } = e.target;
    setSelectedItems(checked ? mnLst.map(item => item.key) : []);
    setIsSelAll(checked);
  };

  useEffect(() => {
    setSelectedItems([]);
    setIsSelAll(false);
  }, [financialYear]);

  const onDwnAgmt = async () => {
    try {
      const payload = { select_all: [...selectedItems] };
      const response = await axiosInstance.post(`/Download-agreement-file/`, payload);
      const lstUrl = response.data.agreement_file_url;

      if (Array.isArray(lstUrl)) {
        lstUrl.forEach((link, i) => {
          setTimeout(() => {
            downloadFile(link);
          }, i * 500);
        });
      } else {
        message.error('Please send data in array of string.');
      }
    } catch (err) {
      console.error(err);
      message.error("Download failed. Please try again.");
    }
  };

  return (
    <div className='my-2 py-4'>
      <Checkbox
        checked={isSelAll}
        onChange={handleSelectAllChange}
        style={{ marginBottom: 16 }}
      >
        Select All
      </Checkbox>

      <Checkbox.Group
        value={selectedItems}
        onChange={handleCheckboxChange}
        style={{ width: '100%' }}
      >
        <Row gutter={[16, 16]}>
          {mnLst.map((item) => (
            <Col span={4} key={item.key}>
              <Space>
                <Checkbox
                  value={item.key}
                  disabled={!enableMonths.includes(item.key)}
                />
                <Button
                  onClick={() => {
                    navigate('/admin/contracts', { state: item });
                  }}
                  disabled={!enableMonths.includes(item.key)}
                >
                  <FolderOpenOutlined style={{ marginRight: "8px", fontSize: 18 }} />
                  {item.label}
                </Button>
              </Space>
            </Col>
          ))}
        </Row>
      </Checkbox.Group>

      <div style={{ marginTop: 20 }}>
        <Button
          onClick={onDwnAgmt}
          type="primary"
          disabled={selectedItems.length === 0}
        >
          Download Agreement
        </Button>
      </div>
    </div>
  );
};

export default MyButtonWithCheckbox;
